import {CheckCircle} from 'lucide-react';
import {createLucideIcon} from '../create-lucide-icon';

export const CheckCircleIcon = createLucideIcon(CheckCircle, 'CheckCircleIcon');
